class ProductSwiper {
    constructor(element) {
      this.element = element;
      this.sectionId = element.dataset.sectionId;
      this.swiper = null;
      this.init();
    }
  
    init() {
      this.initSwiper();
      this.initBottomNavigation();
      this.initMoreButtons();
      this.initCartForms();
    }
  
    initSwiper() {
      const swiperElement = this.element.querySelector('.product-swiper');
      
      // Find highlighted slide index
      const highlightedSlide = swiperElement.querySelector('.swiper-slide[data-highlight="true"]');
      let initialSlide = 0;
      
      if (highlightedSlide) {
        const slides = swiperElement.querySelectorAll('.swiper-slide');
        slides.forEach((slide, index) => {
          if (slide.dataset.highlight === 'true') {
            initialSlide = index;
          }
        });
      }
      
      this.swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        initialSlide: initialSlide,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange: () => {
            this.updateBottomNavigation();
          },
          init: () => {
            // Set initial active state after swiper is fully initialized
            this.updateBottomNavigation();
          }
        }
      });
    }
  
    initBottomNavigation() {
      const navSteps = this.element.querySelectorAll('.nav-step');
      
      navSteps.forEach((step, index) => {
        step.addEventListener('click', () => {
          this.swiper.slideTo(index);
        });
      });
    }
  
    updateBottomNavigation() {
      const navSteps = this.element.querySelectorAll('.nav-step');
      
      // Check if swiper is initialized and has activeIndex
      if (!this.swiper || this.swiper.activeIndex === undefined) {
        return;
      }
      
      const activeIndex = this.swiper.activeIndex;
      
      navSteps.forEach((step, index) => {
        if (index === activeIndex) {
          step.classList.add('active');
        } else {
          step.classList.remove('active');
        }
      });
    }
  
    initMoreButtons() {
      const moreLinks = this.element.querySelectorAll('.more-link');
      
      // More links are already handled by their href attribute
      // No additional JavaScript needed as they're proper anchor tags
    }
  
    initCartForms() {
      const forms = this.element.querySelectorAll('.product-form');
      
      forms.forEach(form => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.addToCart(form);
        });
      });
    } 
  
    async addToCart(form) {
      const button = form.querySelector('.product-form__submit');
      const originalText = button.textContent;
      
      // Show loading state
      button.textContent = 'Adding...';
      button.disabled = true;
      
      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const result = await response.json();
          
          // Show success state
          button.textContent = 'Added!';
          
          // Update cart drawer/counter if it exists
          this.updateCartUI();
          
          // Reset button after delay
          setTimeout(() => {
            button.textContent = originalText;
            button.style.background = '';
            button.disabled = false;
          }, 2000);
          
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        
        // Show error state
        button.textContent = 'Error';
        
        // Reset button after delay
        setTimeout(() => {
          button.textContent = originalText;
          button.style.background = '';
          button.disabled = false;
        }, 2000);
      }
    }
  
    updateCartUI() {
  // Get the mini cart element and section data (following theme patterns)
  const cartDrawer = document.querySelector('cart-drawer');
  const miniCart = document.querySelector('mini-cart');
  
  if (cartDrawer && miniCart) {
    // Use the theme's cart refresh event (matches CartDrawer.onCartRefresh pattern)
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { 
        open: true  // This tells the cart drawer to open after refresh
      }
    }));
  } else {
    // Fallback: update cart counter manually and try to open any drawer
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart bubble (matches the theme's cart-icon-bubble pattern)
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          // Update the count in the bubble
          const countElement = cartIconBubble.querySelector('.cart-count-bubble');
          if (countElement) {
            countElement.textContent = cart.item_count;
            // Show/hide bubble based on count (following theme logic)
            if (cart.item_count > 0) {
              countElement.classList.remove('hidden');
            } else {
              countElement.classList.add('hidden');
            }
          }
        }
        
        // Try to open any available drawer (following MenuDrawer.openMenuDrawer pattern)
        const menuDrawer = document.querySelector('cart-drawer');
        if (menuDrawer && typeof menuDrawer.openMenuDrawer === 'function') {
          menuDrawer.openMenuDrawer();
        }
        
        // Dispatch the theme's standard cart update events
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart }
        }));
        
      })
      .catch(error => {
        console.error('Error updating cart UI:', error);
      });
  }
}
  }
  
  // Initialize all product swipers when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    const productSwipers = document.querySelectorAll('.product-swiper-section');
    productSwipers.forEach(element => {
      new ProductSwiper(element);
    });
  });
  
  // Handle Shopify section editor updates
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      const swiperSection = section.querySelector('.product-swiper-section');
      if (swiperSection) {
        new ProductSwiper(swiperSection);
      }
    });
    
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target;
      const swiperSection = section.querySelector('.product-swiper-section');
      if (swiperSection && swiperSection.swiper) {
        swiperSection.swiper.destroy(true, true);
      }
    });
  }
  